import React from 'react';

import TextArea from './TextArea';
import I18n from '../../locales/i18n';

function ForumPost(props) {
	return (
		<div className="Forum__header">
			<TextArea
				onSend={props.onSend}
				placeholder={I18n('CHAT', 'WRITE_YOUR_QUESTION')}
				photoURL={props.photoURL}
			/>
		</div>
	);
}

export default ForumPost;
